module.exports = __webpack_public_path__ + "static/media/SeekerSignal.0e47cbf9.png";